module.exports = __webpack_public_path__ + "static/banner-e410953f5b8c22706725f1175f49f12a.jpg";